import React, { useState } from "react";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import Swal from "sweetalert2";
import useApi from "../../../core/customhook/useApi";
import dayjs from "dayjs";
import Loader from "../../../core/common/selfLoder";
import { getFinancialYearList } from "../../../core/common/financialYear";

const OutdutyDetails = () => {
  const navigate = useNavigate();
  const [modalData, setModalData] = useState<any>({});

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    return formatFinancialYear(year);
  };

  const [finance_year, setFinance_year] = useState(getFinancialYear());

  const columns = [
    {
      title: "AppDate",
      dataIndex: "application_date",
      render: (text: string) =>
        text ? dayjs(text).format("D MMMM YYYY") : "------",
      sorter: (a: any, b: any) =>
        dayjs(a.application_date).valueOf() - dayjs(b.application_date).valueOf(),
    },
    {
      title: "Slice",
      dataIndex: "od_slice_type",
      sorter: (a: any, b: any) => a.od_slice_type - b.od_slice_type,
    },
    {
      title: "From",
      dataIndex: "from_date",
      render: (text: string) =>
        text ? dayjs(text).format("D MMMM YYYY") : "------",
      sorter: (a: any, b: any) =>
        dayjs(a.from_date).valueOf() - dayjs(b.from_date).valueOf(),
    },

    {
      title: "To",
      dataIndex: "to_date",
      render: (text: string) =>
        text ? dayjs(text).format("D MMMM YYYY") : "------",
      sorter: (a: any, b: any) =>
        dayjs(a.to_date || 0).valueOf() - dayjs(b.to_date || 0).valueOf(),
    },
    {
      title: "Day",
      dataIndex: "Days",
      sorter: (a: any, b: any) => a.Days - b.Days,
    },

    {
      title: "Type",
      dataIndex: "od_type",
      sorter: (a: any, b: any) => a.leave_type.localeCompare(b.leave_type),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <span
          className={`badge ${text.toLowerCase().includes("approved")
            ? "bg-success"
            : text.toLowerCase().includes("rejected")
              ? "bg-danger"
              : "bg-warning"
            }`}
        >
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    },
    // {
    //   title: "Reason",
    //   dataIndex: "reject_reason",
    //   render: (text: any, record: any) => (
    //     <>
    //       {record.status === "rejected" ? (
    //         <i className="fa fa-eye"></i>
    //       ) : (
    //         "-----"
    //       )}
    //     </>
    //   ),
    // },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: string, record: any) => {
        const isApproved =
          record.status === "APPROVED" || record.status === "REJECTED";
        return (
          <div className="action-icon d-inline-flex">
            <Link
              to="#"
              className="text-success"
              title="View"
              data-bs-toggle="modal"
              data-bs-target={`${record.status === "APPROVED"
                ? "#approve-modal"
                : record.status === "REJECTED"
                  ? "#rejected-modal"
                  : "#apply-modal"
                }`}
              onClick={() => {
                setModalData(record);
              }}
            >
              <i className="ti ti-eye" />
            </Link>
            <button
              className="btn btn-sm out-linetext-info"
              style={{
                cursor: isApproved ? "not-allowed" : "pointer",
              }}
              title="Edit"
              onClick={() => {
                if (!isApproved) handleEdit(record);
              }}
            >
              <i className="ti ti-edit" />
            </button>{" "}
            <Link
              to="#"
              className="text-danger"
              style={{
                cursor: isApproved ? "not-allowed" : "pointer",
              }}
              title="Delete"
              onClick={() => {
                if (!isApproved) deleteRequest(record?.od_application_id);
              }}
            >
              <i className="ti ti-trash" />
            </Link>
          </div>
        );
      },
    },
  ];

  const handleEdit = (record: any) => {
    localStorage.setItem("editodData", JSON.stringify(record));
    navigate("/edit-out-duty-application");
  };
  const {
    data: outduty_details,
    loading: outduty_details_loading,
    error: outduty_Details_error,
    callApi: fetchLeaveDetails,
  } = useApi("/api/view-od-status", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies:[finance_year]
  });


  const data = outduty_details?.data.map((item: any, index: number) => {
    return {
      ...item,
      Days: item.days === null ? "------" : item.days
    };
  });

  const {
    data: request_delete,
    loading: request_delete_loading,
    error: request_delete_error,
    callApi: deleteLeaveRequest,
  } = useApi("/api/delete-leave/:id", {
    method: "DELETE",
    autoCall: false,
  });

  const deleteRequest = async (request_id: any) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this od request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (confirmResult.isConfirmed) {
      try {
        const response = await deleteLeaveRequest(
          undefined,
          `/api/delete-od/${request_id}`
        );
        console.log(response);
        if (response.statusCode === 200) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text:
              response?.message ||
              "Leave request has been deleted successfully.",
            timer: 2000,
            showConfirmButton: true,
          });
          await fetchLeaveDetails();
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: "Could not delete the leave request.",
          });
        }
      } catch (error) {
        console.error("Delete failed:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while deleting the leave request.",
        });
      }
    }
  };

  const formatLongDate = (date?: string) =>
    date ? dayjs(date).format("D MMMM YYYY") : "N/A";


  return (
    <>
      {/* <Loader loading={outduty_details_loading || request_delete_loading} /> */}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Out Duty Details</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">OD</li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.selfOutDutyGrid}>Self Out Duty</Link>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    Out Duty Details
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div>
                <Link
                  to="/out-duty-application"
                  className="btn btn-primary custom_button py-1 px-3"
                >
                  Apply Outduty
                </Link>
              </div>
              <div className="me-2 mb-2"></div>
              <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>
              <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {getFinancialYearList().map((fy) => (
                    <option key={fy} value={fy}>
                      {fy.split("-")[0]}
                    </option>
                  ))}
                </select>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body p-0">
              <Table dataSource={data} columns={columns} Selection={false} showSearchInput={true} />
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      {/* modal */}

      <div
        id="approve-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="approve-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header  text-white">
              <h5 className="modal-title" id="approve-modalLabel">
                OD Application Approved
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <strong>Approved By:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.approved_by_name === null
                    ? modalData?.approved_by
                    : modalData?.approved_by_name}
                </p>
              </div>

              <div className="mb-3">
                <strong>Approved On:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.approved_on
                    ? dayjs(modalData.approved_on).format("DD-MMMM-YYYY hh:mm A")
                    : "N/A"}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Rejected  */}
      <div
        id="rejected-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="rejected-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header text-white">
              <h5 className="modal-title" id="rejected-modalLabel">
                OD Application Rejected
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <strong>Rejected By:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejected_by_name === null
                    ? modalData?.rejected_by
                    : modalData?.rejected_by_name}
                </p>
              </div>

              <div className="mb-3">
                <strong>Rejection Reason:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejection_reason || "N/A"}
                </p>
              </div>

              <div className="mb-3">
                <strong>Rejected On:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejected_on
                    ? dayjs(modalData.rejected_on).format("DD-MMMM-YYYY hh:mm A")
                    : "N/A"}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Apply */}

      <div
        id="apply-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="apply-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header  text-white">
              <h5 className="modal-title" id="apply-modalLabel">
                OD Application Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <strong>OD Type:</strong>
                  <p className="text-muted">{modalData?.od_type || "N/A"}</p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>OD Slice:</strong>
                  <p className="text-muted">
                    {modalData?.od_slice_type || "N/A"}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>From Date:</strong>
                  <p className="text-muted">{formatLongDate(modalData?.from_date)}</p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>To Date:</strong>
                  <p className="text-muted">{formatLongDate(modalData?.to_date)}</p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Number of Days:</strong>
                  <p className="text-muted">{modalData?.Days || "N/A"}</p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Application Date:</strong>
                  <p className="text-muted">{formatLongDate(modalData?.application_date)}</p>
                </div>

                <div className="col-12 mb-3">
                  <strong>Reason:</strong>
                  <p className="text-muted">
                    {modalData?.application_reason || "N/A"}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Manager Email:</strong>
                  <p className="text-muted">
                    {modalData?.manager_email_id || "N/A"}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>CC Email:</strong>
                  <p className="text-muted">{modalData?.cc_email || "N/A"}</p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Status:</strong>
                  <p>
                    <span
                      className={`badge ${modalData?.status === "APPROVED"
                        ? "bg-success"
                        : modalData?.status === "REJECTED"
                          ? "bg-danger"
                          : "bg-warning text-dark"
                        }`}
                    >
                      {modalData?.status || "PENDING"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OutdutyDetails;
